export const spectrum_articles = [
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/LCM3IQBVMFH7XLNPOEDOSDXBVI.jpg?auth=1571452e4a6930c23ee44a12dfece9d976ae1f1091b232db85e6c70db98792b1",
        article_title: "Who was Zora Neale Hurston, BC 1928?",
        article_authors: "Loyca Jean",
        article_link: "https://www.columbiaspectator.com/spectrum/2025/02/10/who-was-zora-neale-hurston-bc-1928/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/SLKMHHP24NCOVF3ZTWXGXKWWTQ.jpg?auth=6816c0520e4463618fcaf9fb114debcd0340f3e749ef6a07fa40d35780d620bd",
        article_title: "Movie recommendations for Black History Month",
        article_authors: "Jasveenkaur Wahan, Ria Dalal, and Manuela Moreyra",
        article_link: "https://www.columbiaspectator.com/spectrum/2025/02/09/movie-recommendations-for-black-history-month/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/2DM5ONXUCZEWFF3XMW2WTPSNXI.jpeg?auth=5e995396bf7736110fe83b8abbbf472c421e3e3f039e60167ac5740e08907b35",
        article_title: "How Black student organizations are celebrating Black History Month",
        article_authors: "Manuela Moreyra",
        article_link: "https://www.columbiaspectator.com/spectrum/2025/02/11/how-black-student-organizations-are-celebrating-black-history-month/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/QUJTBNXWIJFPBD3B6R5CDH4T4A.jpg?auth=1aaa28ae867ec3fa54cb44370b6ea6e3fd628c55ac83a53339b26f67e98cfc91",
        article_title: "Six spots near campus to discover Harlem’s rich culture this Black History Month",
        article_authors: "Mulki Ahmed  ",
        article_link: "https://www.columbiaspectator.com/spectrum/2025/02/13/six-spots-near-campus-to-discover-harlems-rich-culture-this-black-history-month/"
    }
];
